export * from './content.page.detail.model';



// WEBPACK FOOTER //
// ./src/models/contentPage/index.ts